import React, { FC, Fragment, useState, useEffect } from 'react';
import {
  Button,
  Dialog as MuiDialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Grid,
  Link,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@material-ui/icons/Close';
import { CustomSVG, UserAvatar } from 'components';
import { isEmpty } from 'lodash';
import classNames from 'classnames';

import { useContent } from 'hooks';
import { generateLink } from 'Links';
import { Events } from 'analytics';

import { ShareDialog } from 'features/sharing';
import useStyles from './styles';
import { ShareCount } from '../index';

const ShareCountModal: FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const content = useContent();
  const users = content.shared_by;

  useEffect(() => {
    if (isOpen) {
      analytics.track(Events.ClickShareCount);
    }
  }, [isOpen]);

  function handleOpenToggle() {
    setIsOpen(!isOpen);
  }

  function handleShareOpenToggle() {
    setShareOpen(!shareOpen);
    handleOpenToggle();
  }

  function renderContent() {
    if (isEmpty(users)) {
      return (
        <Grid container direction="column" alignItems="center" justify="center">
          <Grid item>
            <Grid container alignItems="center" item>
              <Typography variant="subtitle1">{t('content:firstToMessage')}</Typography>
              <Button
                variant="contained"
                size="large"
                className={classes.dialogButton}
                startIcon={<CustomSVG name="share" color="primary" />}
                onClick={handleShareOpenToggle}>
                <Typography color="primary">{t(`content:share`)}</Typography>
              </Button>
            </Grid>
          </Grid>

          <ShareDialog onClose={handleShareOpenToggle} open={shareOpen} />
        </Grid>
      );
    }

    return (
      <Grid container direction="column" alignItems="flex-start" justify="flex-start">
        {users.map((user, idx) => {
          return (
            <Grid item key={idx} container alignItems="center" spacing={2} className={classes.user}>
              <Grid item className={classes.avatar}>
                <UserAvatar link size={40} user={user} />
              </Grid>
              <Grid item>
                <Link variant="body2" component={generateLink(`/profile/${user.id}`)} noWrap>
                  {user.full_name}
                </Link>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    );
  }

  return (
    <Fragment>
      <Link onClick={handleOpenToggle} className={classes.link}>
        <ShareCount />
      </Link>

      {isOpen && (
        <MuiDialog
          fullWidth
          open={isOpen}
          onClose={handleOpenToggle}
          onBackdropClick={handleOpenToggle}
          classes={{
            paper: classNames({
              [classes.dialogPaper]: !isEmpty(users),
              [classes.emptyDialogPaper]: isEmpty(users),
            }),
          }}>
          <DialogTitle disableTypography>
            <ShareCount variant="subtitle2" />
            <IconButton onClick={handleOpenToggle}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent classes={{ root: classes.dialogContent }}>{renderContent()}</DialogContent>
        </MuiDialog>
      )}
    </Fragment>
  );
};

export default ShareCountModal;
